<template>
  <div class="sales">
      <div>
        <div class="wechatApp-wrap">
          <!-- 基础包 -->
          <div class="basic">
            <div class="title weight">工家云</div>
            <!-- -->
            <div
              class="basicfirst-model-wrap"
              v-if="!allSelected || (allSelected && year.index>0)"
              :class="{newactive:basicNum>0}"
            >
              <div class="basic-funcs fx-row fx-row-center">
                <div class="basic-func" v-for="(fun,index) in funs" :key="index">
                  <img :src="fun.image" />
                  <div class="title">{{fun.name}}</div>
                  <div class="desc" v-html="fun.desc"></div>
                </div>
              </div>
              <van-tabs 
              v-model="activetabUser"
              @change="handleChangeTabUser"
              title-active-color="#E64A3E"
              color="#E64A3E"
              >
              <van-tab title="白名单用户" name="bmduser">
                <div class="main-select-wrap">
                  <div class="main-select">
                    <div class="fx-row fx-row-center" @click="showNum= true">
                      <div class="label">人数</div>
                      <div class="fx-1 arrow-wrap">
                        <span class="value active">{{num.label}}</span>
                        <span class="iconfont icon-h5-arrowright"></span>
                      </div>
                    </div>
                  </div>
                  <div class="main-select">
                    <div class="fx-row fx-row-center" @click="showYear=true">
                      <div class="label">使用时长</div>
                      <div class="fx-1 arrow-wrap">
                        <span class="value" :class="{active:year.label!=='请选择'}">{{year.label}}</span>
                        <span class="iconfont icon-h5-arrowright"></span>
                      </div>
                    </div>
                  </div>
                  <div class="basic-price-wrap">
                    <div class="fx-row fx-row-center">
                      <div class="label" v-show="year.index%3!=0">
                        ￥{{(num.price*year.index).toFixed(2)}}
                      </div>
                      <div class="label" v-show="year.index%3==0">
                        ￥{{(num.price*year.index*0.8).toFixed(2)}}
                      </div>
                      <div class="fx-1">
                        <div class="fx-row fx-row-center fx-row-right">
                          <span
                            class="discount"
                            v-show="year.index>=3 && year.index%3==0"
                          >已优惠{{(num.price*year.index*0.2).toFixed(2)}}</span>
                          <!-- <van-stepper min="0" v-model="basicNum" /> -->
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="main-select">
                    <div class="fx-row fx-row-center" @click="showNum= true">
                      <div class="label">3年一次性付款，享8折优惠</div>
                    </div>
                  </div>
                </div>
                </van-tab>
               <van-tab title="开放注册用户" name="openuser">
                  <div class="main-select-wrap">
                    <div class="main-select">
                      <div class="fx-row fx-row-center" >
                        <div class="label person" @click="showPopup">人数
                        <img class="ts" src="../../assets/images/ts.png" />
                        </div>
                        <div class="fx-1 arrow-wrap">
                          <van-stepper
                          @change="changeOpenNum(openNum)"
                           min="10000" v-model="openNum" input-width="50px" button-size="32px" step="1000"/>
                        </div>
                      </div>
                    </div>
                   <div class="main-select">
                     <div class="fx-row fx-row-center" @click="showopenYear=true">
                       <div class="label">使用时长</div>
                       <div class="fx-1 arrow-wrap">
                         <span class="value" :class="{active:openyear.label!=='请选择'}">{{openyear.label}}</span>
                         <span class="iconfont icon-h5-arrowright"></span>
                       </div>
                     </div>
                   </div>
                    <div class="basic-price-wrap">
                      <div class="fx-row fx-row-center">
                        <div class="label">￥{{((openNum-10000)/1000*3000+30000)*openyear.index}}</div>
                      </div>
                    </div>
                  </div>
                  </van-tab>
             </van-tabs>
            </div>
          </div>
          <!-- 活动包 -->
         <!-- <div class="basic">
            <div class="title weight">实施费用</div>
            <div v-for="fun in addonFuns" :key="fun.name">
              <div v-if="!allSelected || (allSelected && fun.selected )">
                <div class="active-item-wrap" v-if="fun.type === 'fixed'">
                  <div
                    class="addon-funcs basicfirst-model-wrap fx-column fx-row-space-around"
                    :class="{newactive:fun.selected}"
                  >
                    <div
                      class="addon-func"
                      :class="{}"
                      @click="toggle(fun)"
                      v-show="(moduleactive===1 && fun.label !=='健步走') || moduleactive ===0"
                    >
                      {{fun.label}}
                      <span v-show="fun.label =='健步走'" style="font-size: 14px;">(仅限小程序)</span>
                    </div>
                    <div class="price-num-wrap fx-row fx-row-center">
                      <div class="price">￥{{fun.price}} <span>{{fun.time}}</span></div>
                      <div class="fx-1">
                        <div class="fx-row fx-row-center fx-row-right">
                          <span
                            class="discount"
                            v-show="(fun.label==='文艺天地(朗诵大赛/摄影大赛/短视频三选一)' || fun.label==='知识闯关') && parseInt(fun.qty/fun.disTime)>0"
                          >已优惠{{fun.discount * (parseInt(fun.qty/fun.disTime))}}</span>
                          <van-stepper
                            min="0"
                            v-model="fun.qty"
                            @change="handleActiveBag(fun, addonFuns)"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- 健步走 --
                <div class="active-item-wrap" v-if="fun.type === 'select'">
                  <div
                    class="addon-funcs basicfirst-model-wrap fx-column fx-row-space-around"
                    :class="{newactive:fun.selected}"
                  >
                    <div class="addon-func" @click="toggle(fun)">
                      {{fun.label}}
                      <span style="font-size: 14px;">(仅限小程序)</span>
                    </div>
                    <div class="time fx-row">
                      <span class="time-text">{{fun.subtitle}}</span>
                      <span class="iconfont ion-ios-arrowdown" @click="showHealthWalking = true"></span>
                    </div>
                    <div class="price-num-wrap fx-row fx-row-center">
                      <div class="price">￥{{fun.price}}</div>
                      <div class="fx-1">
                        <div class="fx-row fx-row-center fx-row-right">
                          <span
                            class="discount"
                            v-show="(fun.subtitle === '不限人数包月价' || fun.subtitle === '不限人数包年价') && parseInt(fun.qty/fun.disTime)>0"
                          >已优惠{{90000 * (parseInt(fun.qty/fun.disTime))}}</span>
                          <span class="discount" v-show="fun.id === 2">已优惠{{90000 * fun.qty}}</span>
                          <van-stepper
                            min="0"
                            v-model="fun.qty"
                            @change="handleHealthActiveBag(fun)"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <div
                  class="active-item-wrap"
                  v-if="fun.type === 'fixed-parent' && (!allSelected || (allSelected && (fun.selected || fun.content[0].selected || fun.content[1].selected )))"
                >
                  <div
                    class="basicfirst-model-wrap course-model-wrap fx-column fx-row-space-around"
                    :class="{newactive:fun.selected, course: fun.type === 'fixed-perent'}"
                  >
                    <div class="addon-func" @click="toggle(fun)">{{fun.label}}</div>
                    <div
                      class="course-wrap"
                      :class="{'course-active-wrap': ele.selected}"
                      v-for="ele in fun.content"
                      :key="ele.subtitle"
                      v-if=" (!allSelected || ( allSelected && ele.selected ))"
                    >
                      <div class="price-num-wrap fx-row fx-row-center">
                        <div class="price">￥{{ele.price}}  <span>{{ele.time}}</span></div>
                        <div class="fx-1">
                          <div class="fx-row fx-row-center fx-row-right">
                            <van-stepper
                              min="0"
                              v-model="ele.qty"
                              @change="handleCourseActiveBag(fun,ele)"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> -->
          <!-- 增值包 -->
          <div class="basic">
            <div class="title weight">实施费用</div>
            <div v-for="(listitem, index) in incrementPackage" :key="listitem.label">
              <!-- 平铺 -->
              <div
                class="active-item-wrap"
                v-if="listitem.type === 'fixed-parent' && (!allSelected || (allSelected && listitem.subselectArr.length>0))"
              >
                <div
                  class="basicfirst-model-wrap course-model-wrap fx-column fx-row-space-around"
                  :class="{newactive:listitem.selected, course: listitem.type === 'fixed-perent'}"
                >
                  <div class="addon-func" @click.stop="toggle(listitem)">{{listitem.label}}</div>
                  <div
                    class="course-wrap"
                    :class="{'course-active-wrap': ele.selected}"
                    v-for="ele in listitem.content"
                    :key="ele.subtitle"
                    v-if="(!allSelected || (allSelected && ele.selected ))"
                  >
                    <div class="time">{{ele.time}}</div>
                    <div class="price-num-wrap fx-row fx-row-center">
                      <div class="price">￥{{ele.price}}<span>{{ele.unit}}</span></div>
                      <div class="fx-1">
                        <div class="fx-row fx-row-center fx-row-right">
                          <van-stepper
                            min="0"
                            v-model="ele.qty"
                            @change="handleTileActiveBag(listitem,ele)"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 只有一个选项 -->
              <div v-if="!allSelected || (allSelected && listitem.selected )">
                <div class="active-item-wrap" v-if="listitem.type === 'fixed'">
                  <div
                    class="addon-funcs basicfirst-model-wrap fx-column fx-row-space-around"
                    :class="{newactive:listitem.selected}"
                  >
                    <div class="addon-func" :class="{}" @click="toggle(listitem)">{{listitem.label}}</div>
                    <div class="price-num-wrap fx-row fx-row-center">
                      <div class="price">￥{{listitem.price}} <span>{{listitem.time}}</span></div>
                      <div class="fx-1">
                        <div class="fx-row fx-row-center fx-row-right">
                          <van-stepper
                            min="0"
                            v-model="listitem.qty"
                            @change="handleActiveBag(listitem, incrementPackage)"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- select -->
                <div class="active-item-wrap" v-if="listitem.type === 'select'">
                  <div
                    class="addon-funcs basicfirst-model-wrap fx-column fx-row-space-around"
                    :class="{newactive:listitem.selected}"
                  >
                    <div class="addon-func" @click="toggle(listitem)">{{listitem.label}}</div>
                    <div class="time fx-row">
                      <span class="time-text">{{listitem.subtitle}}</span>
                      <span
                        class="iconfont ion-ios-arrowdown"
                        @click="showIncrementSelectClick(index)"
                      ></span>
                    </div>
                    <div class="price-num-wrap fx-row fx-row-center">
                      <div class="price">￥{{listitem.price}}</div>
                      <div class="fx-1">
                        <div class="fx-row fx-row-center fx-row-right">
                          <van-stepper
                            min="0"
                            v-model="listitem.qty"
                            @change="handleHealthActiveBag(listitem)"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 既有平铺又有下拉选项的 物联网模块 -->
              
              <div
                class="active-item-wrap"
                v-if="listitem.type === 'mixin'  && (!allSelected || (allSelected && listitem.subselectArr.length>0))"
              >
                <div
                  class="basicfirst-model-wrap course-model-wrap fx-column fx-row-space-around"
                  :class="{newactive:listitem.selected}"
                >
                  <div class="addon-func" @click="toggle(listitem)">{{listitem.label}}</div>
                  <div
                    class="course-wrap"
                    v-for="(ele, key) in listitem.content"
                    :class="{'course-active-wrap': (ele.type==='tile'?ele.selected:ele.subcontent.selected)}"
                    :key="ele.subtitle"
                    v-show="!allSelected || (allSelected && (ele.type==='tile'?ele.selected : ele.subcontent.selected))"
                  >
                    <div class="block-wrap" v-if="ele.type==='tile'">
                      <div class="time">{{ele.time}}</div>
                      <div class="price-num-wrap fx-row fx-row-center">
                        <div class="price">￥{{ele.price}} <span>{{ele.unit}}</span>
                        </div>
                        <div class="fx-1">
                          <div class="fx-row fx-row-center fx-row-right">
                            <van-stepper
                              min="0"
                              v-model="ele.qty"
                              @change="handleMixActiveBag(listitem,ele,key)"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="block-wrap" v-else>
                      <div class="subcontent-wrap">
                        <div class="time fx-row">
                          <span class="time-text">{{ele.subcontent.subtitle}}</span>
                          <span
                            class="iconfont ion-ios-arrowdown"
                            @click="showIncrementMixClick(key,ele)"
                          ></span>
                        </div>
                        <div class="price-num-wrap fx-row fx-row-center">
                          <div class="price">￥{{ele.subcontent.price}}<span>{{ele.subcontent.unit}}</span>
                            <div v-show="ele.subcontent.subtitle == '人脸识别系统(租用)2天起租' "> 每增1天增加￥4000</div>
                          </div>
                          <div class="fx-1">
                            <div class="fx-row fx-row-center fx-row-right">
                              <van-stepper
                                v-if="ele.subcontent.subtitle == '人脸识别系统(租用)2天起租' "
                                min="0"
                                step="1"
                                v-model="ele.subcontent.qty"
                                @change="handleMixActiveBag(listitem,ele,key)"
                                @minus="handleMixMinus(listitem,ele,key)"
                              />
                              <van-stepper
                                v-else
                                min="0"
                                @minus="handleMixMinus(listitem,ele,key)"
                                v-model="ele.subcontent.qty"
                                @change="handleMixActiveBag(listitem,ele,key)"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="price-total">
          <div class="fx-row fx-row-center">
            <van-button
              v-if="!allSelected"
              class="view"
              round
              type="danger"
              size="small"
              plain
              @click="handleView()"
            >仅看已选</van-button>
            <van-button
              v-if="allSelected"
              class="view"
              round
              size="small"
              type="danger"
              @click="handleView()"
            >仅看已选</van-button>
            <div class="fx-1">
              <span class="label">总计</span>
              <span class="value">¥{{price}}</span>
            </div>
          </div>
        </div>
      </div>
   <!--   <van-tab title="特惠套餐" name="thtc">
        <div class="discount-wrap">
         
          <div class="discount-tips">套餐价格包含期初配置费用和3次活动上线配置费用。基础包1年内有效，且每次活动时间不超过30天。</div>
         
          <div class="discount-content-wrap">
            <div class="discount-content" v-for="(item, index) in discountPackage" :key="index">
              <div class="fx-row discount-title">
                <div class="limit-num fx-1">{{item.label}}</div>
                <div class="limit-price">￥{{item.price}}</div>
              </div>
              <div class="discount-data-wrap">
                <div
                  class="discount-data fx-row fx-row-center"
                  v-for="(ele, i) in item.content"
                  :key="i"
                >
                  <div class="data-title fx-1">{{ele.title}}</div>
                  <div class="data-time">{{ele.time}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </van-tab> -->

    <!-- 基础包选择人数的弹窗 -->
    <van-popup v-model="showNum" position="bottom">
      <van-picker
        show-toolbar
        @cancel="onCancel"
        :columns="nums"
        value-key="label"
        @confirm="onChange"
      />
    </van-popup>
    <!--  基础包选择时间的弹窗 -->
    <van-popup v-model="showYear" position="bottom">
      <van-picker
        show-toolbar
        @cancel="onCancelYear"
        :columns="years"
        value-key="label"
        @confirm="onChangeYear"
      />
    </van-popup>
   <van-popup v-model="showopenYear" position="bottom">
      <van-picker
        show-toolbar
        @cancel="onCancelopenYear"
        :columns="years"
        value-key="label"
        @confirm="onChangeopenYear"
      />
    </van-popup>
    <!-- 健步走的弹窗 -->
    <van-popup v-model="showHealthWalking" position="bottom">
      <van-picker
        show-toolbar
        @cancel="onCancelWalking"
        :columns="addonFuns[addonFuns.length-1].personnum"
        value-key="subtitle"
        @confirm="onChangeWalking"
      />
    </van-popup>

    <!-- 增值包中只有下拉的弹窗increment -->
    <van-popup v-model="showIncrementSelect" position="bottom">
      <van-picker
        show-toolbar
        @cancel="onCancelIncrementSelect"
        :columns="incrementPackage[selectIndex]['content']"
        value-key="subtitle"
        @confirm="onChangeIncrementSelect"
      />
    </van-popup>
   <van-popup v-model="showIncrementMix" position="bottom">
      <van-picker
        show-toolbar
        @cancel="onCancelIncrementMix"
        :columns="incrementPackage[minIndex]['content'][mixSelectIndex]['subcontent']['list']"
        value-key="subtitle"
        @confirm="onChangeIncrementMix"
      />
    </van-popup>
   <van-dialog v-model="show" title="说明" confirm-button-color="red">
       <div class="content-dialog">人数每次可增加1000人，每增加1000人，价格相应增加3000元。</div>
   </van-dialog>
  </div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import { constants } from "crypto";
import saleData from "./saleData.json";
export default {
  name: "",
  data() {
    return {
      allSelected: false, // 是否展示全部选中项
      activetab: 0,
      activetabUser:0,
      selectIndex: 0,
      show:false,//提示弹窗
      showNum: false,
      showSpecs: false,
      showYear: false,
      showopenYear: false,
      addeduser: 1,
      active: 0,
      moduleactive: 0,
      num: {
        label: "1至300人",
        price: 2888,
        time: 1,
        unitprice: [
          {
            time: 1,
            price: 2888
          },
          {
            time: 2,
            price: 20000
          }
        ]
      },
      openNum:10000,
      specs: saleData.runYear,
      year: {
        index: 0,
        label: "请选择",
        qty: 1
      },
      openyear:{
        index: 0,
        label: "请选择",
        qty: 1,
        },
      years: saleData.years,
      nums: saleData.nums, //人数
      showpop:false,//人数弹窗
      funs: [
        {
          image: require("@/assets/images/basic/sjk.png"),
          name: "数据库",
          desc:
            "可新建工会组织架构，对工会会员会籍实名、实时管理。可自定义验证字段。"
        },
        {
          image: require("@/assets/images/basic/qxfp.png"),
          name: "权限分配",
          desc: "子管理员可添加子管理，并分配对应的功能模块权限。"
        },
        {
          image: require("@/assets/images/basic/txl.png"),
          name: "通讯录",
          desc:
            "工会可建设通讯录系统，工会成员可在通讯录查询其他成员信息并拨打电话。"
        },
        {
          image: require("@/assets/images/basic/xxfb.png"),
          name: "信息发布",
          desc:
            "随心配置信息发布内容，支持新建信息发布分类如最新资讯、工会新闻等，支持分类管理；支持可视化后台管理；提供新闻内容库选取；支持公众号文章导入（需授权）。"
        },
        {
          image: require("@/assets/images/basic/jfxt.png"),
          name: "积分系统",
          desc:
            "工会管理员可根据需求向工会成员进行积分充值，支持设置积分兑换比例等规则，支持查看会员积分情况。可配置多种模块的获取积分规则，包括每日签到，健步走，活动报名，可后台人工加减积分。"
        },
        {
          image: require("@/assets/images/basic/cj.png"),
          name: "积分抽奖",
          desc:
            "支持设置积分抽奖规则。工会会员可凭工会积分进行抽奖，中奖后由平台以工会名义发放或由工会自行发放。支持物流配送（限平台内选购商品）；支持名单导出。"
        },
        {
          image: require("@/assets/images/basic/jfqd.png"),
          name: "积分签到",
          desc:
            "支持签到规则配置。工会会员登陆平台后可签到领取积分，使用于注重会员活跃度的工会组织。"
        },
        {
          image: require("@/assets/images/basic/sc.png"),
          name: "商城",
          desc:
            "工会管理员可进行福利积分的发放、福利商品的管理，工会会员可通过福利商城进行商品选择，以积分进行消费。积分不足的部分可用微信支付补足，支持电子签收，由平台提供商品物流。提供可视化管理后台；支持规则配置；支持商品定制选择；支持数据导出。工会福利商城平台与各大电商、电影、蛋糕、JD商品、生鲜、场地预定、票务预定等平台系统实现互通，让各项商品和服务通过简单的操作即可赋能工会各种应用场景，例如职工慰问、会员福利、活动奖品等。"
        },
        {
          image: require("@/assets/images/basic/pqdh.png"),
          name: "票券兑换平台",
          desc:
            "工会管理员可进行指定上班族提供产品的发放，系统将发放对应的一张电子卡券，员工可以凭卡券兑换指定的商品，通过系统平台进行物流发放，宅配到家，并支持电子签收，提供可视化管理后台。"
        },
        {
          image: require("@/assets/images/basic/qg.png"),
          name: "抢购平台",
          desc:
            "支持会员开放式和非开放式抢购进入，支持多种商品多件抢购，可以配置商品限制配送区域，礼品支持工会自有供应商和上班族供应商。稳定性高，已成功服务过上百次单次人员数量过万的抢购活动。"
        },
        {
          image: require("@/assets/images/basic/dzqs.png"),
          name: "电子签收功能",
          desc:
            "实现实名签收工作，后台可以一键导出所有审计所需资料（姓名、提领货物、单价、数量、总计、个人签名等）。"
        },
        {
          image: require("@/assets/images/basic/bm.png"),
          name: "活动报名",
          desc:
            "管理员可发布各类报名活动，工会人员线上报名，活动形成二维码，二维码可直接用于现场签到。提供场馆接入服务，支持保证金体系，支持数据导出。"
        },
        {
          image: require("@/assets/images/basic/tp.png"),
          name: "投票系统",
          desc:
            "建立投票系统，工会管理员发布各类候选人、候选作品信息至工会平台，工会会员进行投票评选，评选结果实时展示。支持数据导出，支持规则配置。"
        },
        {
          image: require("@/assets/images/basic/ghxx.png"),
          name: "工会信箱",
          desc:
            "支持移动端互动留言消息提醒；支持管理员在移动端、PC端回复并管理留言信息。"
        },
        {
          image: require("@/assets/images/basic/wjxz.png"),
          name: "文件下载",
          desc:
            "支持工会管理员上传各类文件（支持Word、Excel、PDF、PPT、MP4、MP3格式）；支持对文件加密；支持分类管理。工会会员可搜索查找并阅读下载各文件，尤其适合办公场所不固定、人员分散的工会组织。"
        },
        {
          image: require("@/assets/images/basic/wjbd.png"),
          name: "自定义表单",
          desc:
            "可根据各种需求配置用户需要填写的表单，配置项可为单行输入、多行输入、单选、下拉、上传图片等。可用于意见调查、入会申请、办卡申请、帮困救助等各种功能的自定义配置。"
        },
        {
          image: require("@/assets/images/basic/zxsh.png"),
          name: "审批",
          desc:
            "可设置多种审批类型，如出差费用报销、节日福利领取审批等，自定义设置审批流程和步骤，节省办公审批人力物力成本，支持将批复流程作为报销单，并支持在线打印报销单功能。"
        },
        {
          image: require("@/assets/images/basic/hysyd.png"),
          name: "会议室预定",
          desc:
            "支持管理员查看预订情况，设置开馆闭馆日历，支持开场提醒，预约人扫码核销入场。支持设置失约规则，有效管理场馆预约秩序。可用于会议室、职工之家所有器材设备的预定。"
        },
        {
          image: require("@/assets/images/basic/lt.png"),
          name: "论坛",
          desc:
            "支持创建多个主题论坛，支持管理员设置是否需要审核帖子功能，支持会员发布、评论、回复、举报，以及管理自己的帖子。"
        },
        {
          image: require("@/assets/images/basic/jlb.png"),
          name: "俱乐部",
          desc:
            "建立工会文体协会系统，支持管理员对新建协会的审批，支持工会会员申请创建协会部并自行管理，适用于协会组织较多、提供活动经费补助的工会组织。支持俱乐部会员发布活动；支持管理员管理经费，制定规则和发布公告；支持超级管理员查看所有经费情况。"
        },
        {
          image: require("@/assets/images/basic/qq.png"),
          name: "鹊桥",
          desc:
            "强大的在线联谊活动功能，支持人脸识别认证技术解决方案，可同企业或跨企业联谊（灵活的开关形式：根据工会会员需求可自由开启或关闭）。支持用户选择自己的性格形象（用卡通形象代表性格）；支持根据性格形象匹配对象；支持根据用户上传的明星照片来为用户匹配对象；支持夫妻相匹配；性格互补匹配等大数据匹配解决方案。为工会单身会员带来超出预期的联谊体验。"
        },
        // {
        //   image: require("@/assets/images/basic/jtcj.png"),
        //   name: "集团集采",
        //   desc: "集团一次性付款采购下级子账户基础功能报价享受5000/年。"
        // },
        {
          image: require("@/assets/images/basic/wy-ls.png"),
          name: "文艺天地-朗诵大赛",
          desc: "支持管理者在发布活动时，设置活动参与规则、投票规则，参与人在指定时间内会员可提交自己的音频作品，最终以网络票选、评委打分等形式决定最终的获奖作品，予以一定奖励。活动结束后查看参与详情，并支持导出数据报表。支持个性化设置活动封面；支持设置参赛起止时间；支持开启审核功能；支持开启投票功能；支持设置是否需要用户填写个人资料；支持活动规则以及置顶等功能设置。"
        },
        {
          image: require("@/assets/images/basic/wy-sy.png"),
          name: "文艺天地-摄影大赛",
          desc: "支持管理在发布活动时，设置活动参与规则、投票规则、选择投稿形式（图片、音频），参与人在指定时间内会员可上传自己的摄影作品，最终以网络票选、评委打分等形式决定最终的获奖作品，予以一定奖励。活动结束后查看参与详情，并支持导出数据报表。支持个性化设置活动封面；支持设置参赛起止时间；支持开启审核功能；支持开启投票功能；支持设置是否需要用户填写个人资料；支持活动规则以及置顶等功能设置。"
        },
        {
          image: require("@/assets/images/basic/wy-dsp.png"),
          name: "文艺天地-短视频",
          desc: "支持上传短视频或查看他人视频作品；可以关注感兴趣的人，及时查看最新的动态；支持视频点赞、评论互动以及分享给好友，并且可以根据所属公司、视频标签、点赞热度查看短视频。"
        },
        {
          image: require("@/assets/images/basic/sbg.png"),
          name: "上班哥上课啦",
          desc: "上班哥系列线上课程，通过活动报名支持物料包宅配到家，在线观看视频跟学跟做，可支持文艺天地作品展示并根据且排行榜派发奖品。"
        },
        {
          image: require("@/assets/images/basic/zscg.png"),
          name: "知识闯关",
          desc: "发布答题活动、设置答题规则，上传题库，查看答题结果。支持导出数据报表。"
        },
        {
          image: require("@/assets/images/basic/jbz.png"),
          name: "健步走（不限人数	）",
          desc: "绑定微信运动进行活动，可支持个人和团体赛，支持地图开启模式，也支持每日完成步数获得奖励。1.竞赛地图：通过每日微信步数累计值解锁地图点，进行文章阅读及知识问答，领取相应奖励。2.健步赛：以个人或团队方式进行累计时间段微信平均步数的比拼，根据排名给予相应奖励。（线下徒步需额外收取1天实施费）"
        },
      ], //基础模块
      addonFuns: saleData.addonFuns, //额外收费
      runYear: saleData.runYear, //新媒体
      otherrun: saleData.otherrun, //实景
      videorun: saleData.videorun, //直播
      basicNum: 0, // 基础包数量
      discountPackage: saleData.discountPackage, // 特惠套餐
      showHealthWalking: false, // 是否显示健步走弹窗
      showIncrementSelect: false, // 是否显示增值包中只有下拉的选项弹窗
      incrementPackage: saleData.incrementPackage, // 增值包
      mixSelectIndex: 0, // 混合选项的index
      showIncrementMix: false, // 是否显示混合的选项,
      minIndex: 5, // 混合模式的位置
    };
  },
  computed: {
    price() {
      //小程序
      let price = 0;
      // 基础模块计算价格
      // switch (this.year.qty) {
      //   case 1:
      //     price = this.num.unitprice[0].price * this.basicNum;
      //     break;
      //   case 2:
      //     if (this.basicNum > 0 && this.basicNum < 3) {
      //       price = this.num.unitprice[1].price * this.basicNum;
      //     } else {
      //       let basicNum = parseInt(this.basicNum / 3);
      //       let undiscountNum = this.basicNum - basicNum * 3;
      //       let discount = this.num.unitprice[1].price * (basicNum * 3) * 0.8;
      //       let undiscount = this.num.unitprice[1].price * undiscountNum;
      //       price = discount + undiscount;
      //     }
      //     break;
      // }
      if(this.activetabUser==0){
         console.log(this.activetabUser,"activetabUser")
        if(this.year.index%3==0){
           price = (this.num.price*this.year.index*0.8)
        }else{
           price = (this.num.price*this.year.index)
        }
      }else if(this.activetabUser==1){
           console.log("openuser")
           price=((this.openNum-10000)/1000*3000+30000)*this.openyear.index
      }
      
      
      // 基础模块计算价格结束

      // 活动包计算价格
      for (var i = 0; i < this.addonFuns.length; i++) {
        if (this.addonFuns[i].type === "fixed-parent") {
          this.addonFuns[i].content.forEach(ele => {
            if (ele.selected) {
              price += ele.price * ele.qty;
            }
          });
        } else {
          if (this.addonFuns[i]["selected"]) {
            switch (this.addonFuns[i].label) {
              case "文艺天地(朗诵大赛/摄影大赛/短视频三选一)":
              case "知识闯关":
                price +=
                  this.addonFuns[i]["price"] * this.addonFuns[i]["qty"] -
                  this.addonFuns[i].discount *
                    parseInt(
                      this.addonFuns[i]["qty"] / this.addonFuns[i].disTime
                    );
                break;

              case "健步走":
                if (this.addonFuns[i].subtitle === "不限人数包月价") {
                  price +=
                    this.addonFuns[i]["price"] * this.addonFuns[i]["qty"] -
                    this.addonFuns[i].discount *
                      parseInt(
                        this.addonFuns[i]["qty"] / this.addonFuns[i].disTime
                      );
                } else {
                  price +=
                    this.addonFuns[i]["price"] * this.addonFuns[i]["qty"];
                }
                break;
              default:
                price += this.addonFuns[i]["price"] * this.addonFuns[i]["qty"];
            }
          }
        }
      }
      // 活动包计算价格结束

      //增值包计算价格
      for (var i = 0; i < this.incrementPackage.length; i++) {
        let incrementPackage = this.incrementPackage[i];
        // 如果是平铺的
        if (incrementPackage.type === "fixed-parent") {
          incrementPackage.content.forEach(ele => {
            if (ele.selected) {
              price += ele.price * ele.qty;
            }
          });
        }
        if (
          incrementPackage.type === "fixed" ||
          incrementPackage.type === "select"
        ) {
          if (incrementPackage.selected) {
            price +=
              (incrementPackage["price"] * 10 * incrementPackage["qty"]) / 10;
          }
        }
        if (incrementPackage.type === "mixin") {
          incrementPackage.content.forEach(ele => {
            if (ele.type === "subSelect") {
              if (ele.subcontent.selected) {
                if (
                  ele.subcontent.subtitle === "人脸识别系统(租用)2天起租" &&
                  ele.subcontent.qty >= 2
                ) {
                  price +=
                    ele.subcontent.price + (ele.subcontent.qty - 2) * 4000;
                }
                if (ele.subcontent.subtitle === "人脸识别系统(购买)") {
                  price += ele.subcontent.price * ele.subcontent.qty;
                }
                if (
                  ele.subcontent.subtitle !== "人脸识别系统(租用)2天起租" &&
                  ele.subcontent.subtitle !== "人脸识别系统(购买)"
                ) {
                  price +=
                    (ele.subcontent.price * 10 * ele.subcontent.qty) / 10;
                }
              }
            } else {
              price += ele["price"] * ele["qty"];
            }
          });
        }
        // if (this.incrementPackage[i]["selected"]) {
        //   price +=
        //     this.incrementPackage[i]["price"] * this.incrementPackage[i]["qty"];
        // }
      }
      //增值包计算价格结束
      return price.toFixed(2);
    }
  },
  methods: {
    // 是否展示已经选择的数据
    handleView() {
      this.allSelected = !this.allSelected;
    },
    // 平铺选择
    handleTileActiveBag(value, item) {
      this.incrementPackage.forEach(ele => {
        if (ele.label === value.label) {
          value.content.forEach(d => {
            if (item.time === d.time) {
              let i = ele.subselectArr.indexOf(d.time);
              if (parseInt(d.qty) === 0) {
                if (i >= 0) {
                  ele.subselectArr.splice(i, 1);
                }
                d.selected = false;
              } else {
                if (i < 0) {
                  ele.subselectArr.push(d.time);
                }
                d.selected = true;
              }
            }
          });
        }
      });
      if (value.subselectArr.length >= value.content.length) {
        value.selected = true;
      } else {
        value.selected = false;
      }
    },
    // 上班哥上课啦选中
    handleCourseActiveBag(value, item) {
      this.addonFuns.forEach(ele => {
        if (ele.label === value.label) {
          value.content.forEach(list => {
            if (item.time === list.time) {
              if (parseInt(list.qty) === 0) {
                list.selected = false;
              } else {
                list.selected = true;
              }
            }
          });
          if (ele.content[0].qty > 0 && ele.content[1].qty > 0) {
            ele.selected = true;
          } else {
            ele.selected = false;
          }
        }
      });
    },
    /**混合模式
     * value 为type = 混合模式 时的数据
     * item 为混合模式下某一项的内容
     * index 为混合模式下某一项的索引
     */
    handleMixActiveBag(value, item, index) {
      console.log(value,item,index)
      let tempsubcontent = {};
      if (item.type === "subSelect") {
        tempsubcontent = value.content[index].subcontent;
        let i = value.subselectArr.indexOf(tempsubcontent.subtitle);
        if (tempsubcontent.subtitle === "人脸识别系统(租用)2天起租") {
          if (tempsubcontent.qty > 1) {
            if (i < 0) {
              value.subselectArr.push(tempsubcontent.subtitle);
            }
            tempsubcontent.selected = true;
          }else if ( tempsubcontent.qty==1){
            tempsubcontent.qty = 2;
          }else {
            if (i >= 0) {
              value.subselectArr.splice(i, 1);
            }
            tempsubcontent.selected = false;
          }
        } else {
          if (tempsubcontent.qty > 0) {
            if (i < 0) {
              value.subselectArr.push(tempsubcontent.subtitle);
            }
            tempsubcontent.selected = true;
          } else {
            if (i >= 0) {
              value.subselectArr.splice(i, 1);
            }
            tempsubcontent.selected = false;
          }
        }
      } else {
        tempsubcontent = value.content[index];
        let i = value.subselectArr.indexOf(tempsubcontent.subtitle);
        if (tempsubcontent.qty > 0) {
          if (i < 0) {
            value.subselectArr.push(tempsubcontent.subtitle);
          }
          tempsubcontent.selected = true;
        } else {
          if (i >= 0) {
            value.subselectArr.splice(i, 1);
          }
          tempsubcontent.selected = false;
        }
      }
      if (value.subselectArr.length >= value.content.length) {
        value.selected = true;
      } else {
        value.selected = false;
      }
    },

    // 混合模式下人脸识别减少时的操作
    handleMixMinus(listitem,ele, key ) {
      if(ele.subcontent.subtitle =='人脸识别系统(租用)2天起租') {
        if(ele.subcontent.qty==2){
          ele.subcontent.qty=0;
        } 
      }
    },
    // 健步走
    handleHealthActiveBag(heal) {
      if (heal.qty > 0) {
        heal.selected = true;
      } else {
        heal.selected = false;
      }
    },
    // 活动包数量改变时的函数
    handleActiveBag(value, list) {
      list.forEach(ele => {
        if (ele.label === value.label) {
          if (parseInt(value.qty) === 0) {
            ele.selected = false;
          } else {
            ele.selected = true;
          }
        }
      });
    },
    // eslint-disable-next-line no-unused-vars
    handleChangeTab(name) {
      this.activetab = name;
    },
    handleChangeTabUser(name){
      console.log(name,"hhh");
      this.activetabUser = name;
    },
    onCancel() {
      this.showNum = false;
    },
    onCancelYear() {
      this.showYear = false;
    },
    onCancelopenYear() {
      this.showopenYear = false;
    },
    onCancelWalking() {
      this.showHealthWalking = false;
    },
    showPopup() {
      this.show=true
    },
    InputIn(item, index, className) {
      let runYearSingle = this.runYear;
      console.log(item, index, className);
      for (let i; i < runYearSingle.length; i++) {
        if ((runYearSingle[i].type = "single")) {
          console.log(runYearSingle[i], indexs);
          if (i === index) {
            item.disabled = false;
            document.getElementsByClassName(className)[index].focus();
          } else {
            items.disabled = true;
          }
        }
      }
    },
    onChange(value) {
      console.log(value,"num")
      this.num = value;
      this.onCancel();
    },
    changeOpenNum(value){
      console.log(value,"openNum")
      this.openNum=value
    },
    onChangeYear(value) {
      console.log(value,"year")
      this.year = value;
      this.onCancelYear();
    },
    onChangeopenYear(value) {
      this.openyear=value;
      this.onCancelopenYear();
    },
    onChangeWalking(val) {
      let addonFuns = this.addonFuns;
      addonFuns[addonFuns.length - 1].subtitle = val.subtitle;
      val.qty = addonFuns[addonFuns.length - 1].qty;
      addonFuns[addonFuns.length - 1].price = val.price;
      addonFuns[addonFuns.length - 1].disTime = val.disTime;
      if (addonFuns[addonFuns.length - 1].qty > 0) {
        addonFuns[addonFuns.length - 1].selected = true;
      } else {
        addonFuns[addonFuns.length - 1].selected = false;
      }
      this.onCancelWalking();
    },
    showIncrementSelectClick(index) {
      this.showIncrementSelect = true;
      this.selectIndex = index;
    },

    showIncrementMixClick(index,ele) {
      this.showIncrementMix = true;
      this.mixSelectIndex = index;
      console.log(ele);
    },
    onCancelIncrementSelect() {
      this.selectIndex = 0;
      this.showIncrementSelect = false;
    },
    onCancelIncrementMix() {
      this.showIncrementMix = false;
    },
    onChangeIncrementSelect(val) {
      let list = this.incrementPackage[this.selectIndex];
      list.subtitle = val.subtitle;
      val.qty = list.qty;
      list.price = val.price;
      list.disTime = val.disTime;
      if (list.qty > 0) {
        list.selected = true;
      } else {
        list.selected = false;
      }
      this.onCancelIncrementSelect();
    },
    onChangeIncrementMix(val) {
      console.log(val,"val")
      let list = this.incrementPackage[this.minIndex]["content"][
        this.mixSelectIndex
      ]["subcontent"];
      list.subtitle = val.subtitle;
      val.qty = list.qty;
      list.price = val.price;
      list.unit = val.unit;
      if (list.qty > 0) {
        list.selected = true;
      } else {
        list.selected = false;
      }
      this.onCancelIncrementMix();
    },
    init() {
      this.num = this.nums[0];
      this.year = this.years[0];
    },
    toggle(fun) {
      if (fun.type === "fixed-parent") {
        fun.selected = !fun.selected;

        fun.content.forEach(ele => {
          if (fun.selected) {
            ele.selected = true;
            ele.qty = 1;
          } else {
            ele.selected = false;
            ele.qty = 0;
          }
        });
      } else if (fun.type === "mixin") {
        fun.selected = !fun.selected;
        fun.content.forEach(ele => {
          ele.selected = fun.selected;
          if (
            ele.type === "subSelect" &&
            ele.subcontent.subtitle !== "人脸识别系统(租用)2个月起"
          ) {
            ele.subcontent.qty = fun.selected ? 1 : 0;
            ele.subcontent.selected = fun.selected;
          } else if (
            ele.type === "subSelect" &&
            ele.subcontent.subtitle === "人脸识别系统(租用)2个月起"
          ) {
            ele.subcontent.qty = fun.selected ? 2 : 0;
            ele.subcontent.selected = fun.selected;
          } else {
            ele.selected = fun.selected;
            ele.qty = fun.selected ? 1 : 0;
          }
        });
      } else {
        fun.selected = !fun.selected;
        if (fun.selected) {
          fun.qty = 1;
        } else {
          fun.qty = 0;
        }
      }
    }
  },
  mounted() {
    this.init();
  }
};
</script>

<style lang="less" scoped>
.sales {
  padding-bottom: 76px;
}
.sales /deep/ .van-hairline--top-bottom:after {
  border: 0;
}
.sales /deep/ .van-tab {
  font-size: 16px;
}
.sales /deep/ .van-tabs__line {
  height: 1px;
}
.sales /deep/ .van-button--danger {
  color: #fff;
  background-color: #e64a3e;
  border: 1px solid #e64a3e;
}
.sales /deep/ .van-button--plain {
  color: #e64a3e;
  background-color: #fff;
}
.basicfirst-model-wrap {
  border-radius: 6px;
  padding: 0;
  border: 1px solid #e4e4e4;
  box-sizing: border-box;
}
.course-model-wrap {
  margin-bottom: 10px;
  padding: 10px 15px;
}
.course-model-wrap .addon-func {
  line-height: 2;
}
.course-model-wrap .time {
  font-size: 13px;
  color: #999;
  margin: 8px 0;
}
.course-model-wrap .course-wrap {
  border-bottom: 1px solid #e4e4e4;
  padding-bottom: 15px;
}
.course-model-wrap .course-wrap:last-child {
  border-bottom: 0;
}
.course-model-wrap .course-wrap.course-active-wrap {
  background: #f0f8ff !important;
}
.basicfirst-model-wrap .top-line {
  height: 10px;
  background: #e4e4e4;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
}
.main-select-wrap {
  padding: 10px 0 5px;
  box-sizing: border-box;
}
.main-select {
  margin-bottom: 5px;
  padding: 6px 10px;
  border-radius: 3px;
  height: 44px;
  box-sizing: border-box;
}
.basic-price-wrap {
  padding: 6px 10px;
}
.basic-price-wrap .label {
  font-size: 16px;
  color: #e64a3e;
  font-weight: bold;
}
.basic-price-wrap .discount {
  font-size: 12px;
  color: #e64a3e;
  margin-right: 10px;
}
.main-select .fx-row {
  height: 100%;
}
.main-select .fx-row .label {
  color: #333;
  font-size: 14px;
  line-height: 20px;
  // border-right: 1px solid #f1f1f1;
  padding-right: 10px;
  box-sizing: border-box;
}
.main-select .fx-row .arrow-wrap {
  text-align: right;
}
.main-select .fx-row .value {
  color: #bbbbbb;
  font-size: 14px;
  text-align: center;
  padding-right: 10px;
  box-sizing: border-box;
}

.main-select .fx-row .value.active {
  color: #333 !important;
}
.main-select .fx-row .iconfont {
  color: #bbbbbb;
  font-size: 12px;
}
.basic {
  background: white;
  padding: 15px;
}
.basic .title {
  color: #333333;
  font-size: 18px;
  margin-bottom: 15px;
}
.basic .weight {
  font-weight: bold;
}
.basic-funcs {
  margin-top: 10px;
  padding: 0 10px;
  box-sizing: border-box;
  white-space: nowrap;
  overflow: scroll;
  -webkit-overflow-scrolling: touch;
}
.basic-func {
  width: 150px;
  box-sizing: border-box;
  display: inline-block;
  background: #fff;
  margin-right: 10px;
  padding: 20px 15px;
  text-align: center;
  border-radius: 4px;
  border: 1px solid #e4e4e4;
}
.basic-func img {
  width: 50px;
  height: 50px;
}
.basic-func .title {
  color: #333333;
  font-size: 14px;
  width: 120px;
}
.basic .title span {
  color: #888888;
  font-size: 14px;
  margin-left: 10px;
}
.basic-func .desc {
  white-space: normal;
  color: #999999;
  font-size: 11px;
  height: 52px;
  overflow: scroll;
  text-align: left;
}
.addon-funcs {
  height: 120px;
  margin-bottom: 10px;
  padding: 10px 15px;
  box-sizing: border-box;
}
.addon-funcs .time {
  font-size: 13px;
  color: #999;
}
.addon-func {
  color: #333333;
  font-size: 16px;
  border-radius: 3px;
}
.basicfirst-model-wrap.newactive {
  // background: #f0f8ff;
  border-radius: 6px;
  border: 1px solid #e0e8f0;
}
.price-num-wrap .price {
  font-size: 15px;
  color: #e64a3e;
  font-weight: bold;
}
.price-num-wrap .discount {
  font-size: 12px;
  color: #e64a3e;
  margin-right: 10px;
}
.run .run-item {
  margin-bottom: 10px;
}
.run .run-item .tips {
  font-size: 11px;
  color: #d44437;
  margin-top: 2px;
}
.run-item .run-left-item {
  height: 35px;
  line-height: 35px;
  background: transparent;
  border-radius: 3px;
  font-size: 16px;
  color: #333;
}
.run-item .run-content {
  padding: 10px;
  box-sizing: border-box;
}
.run-item .run-content-singleAdd {
  padding: 20px 10px;
  box-sizing: border-box;
}
.run-item .run-right-item {
  flex: 0 0 160px;
  width: 160px;
  height: 35px;
  line-height: 35px;
  margin-left: 6px;
  font-size: 11px;
  color: #999;
  box-sizing: border-box;
}
.run-right-item .num {
  width: 100%;
  height: 32px;
  line-height: 32px;
  padding: 0;
  margin: 0;
  text-align: right;
  border: 0;
  box-sizing: border-box;
  background: transparent;
}

.select-show-wrap .num {
  height: 30px;
  line-height: 30px;
  padding: 0;
  margin: 0;
  text-align: right;
  border: 0;
  box-sizing: border-box;
  background: transparent;
}
.run-right-item .num,
.run-right-item .unit,
.run-item .select-right-item .num,
.run-item .select-right-item .unit {
  font-size: 14px;
  color: #333;
}
.run-item .run-left-item.active,
.run-item .select-left-item.active {
  color: white;
  background: #2da4de;
}
.run-item.active .title {
  color: white;
}
.run-item .title {
  white-space: nowrap;
  margin: 0;
  font-size: 11px;
  overflow: hidden;
  text-overflow: ellipsis;
}
.new-select-wrap {
  padding: 10 15px;
  box-sizing: border-box;
}
.select-left-item {
  background: transparent;
  border-radius: 3px;
  font-size: 16px;
  color: #333;
}
.select-right-item {
  margin-top: 2px;
  border-radius: 3px;
  box-sizing: border-box;
}
.select-right-item .select-wrap {
  height: 35px;
  line-height: 35px;
  padding-right: 10px;
  box-sizing: border-box;
}
.select-right-item .select-wrap .value,
.select-right-item .select-show-wrap .qty,
.run-right-item .qty {
  text-align: center;
  font-size: 14px;
  color: #333;
}
.select-right-item .select-wrap .iconfont {
  font-size: 10px;
  color: #333;
}
.select-right-item .select-show-wrap {
  flex: 0 0 160px;
  width: 160px;
  height: 35px;
  line-height: 35px;
}
.step-icon {
  font-size: 18px;
  color: #333;
}
.step-icon.disabled {
  color: #999;
}
.step {
  font-size: 12px;
}
.adduser .title {
  color: #726f83;
}
.adduser .step-icon {
  font-size: 18px;
  color: #333;
}
.adduser .step {
  font-size: 14px;
}
.price-total {
  position: fixed;
  bottom: 0;
  right: 0;
  left: 0;
  padding: 10px 24px;
  text-align: right;
  background: #f4f4f4;
  box-sizing: border-box;
}
.price-total .label {
  color: #3a3e41;
  font-size: 14px;
  margin-right: 10px;
}
.price-total .value {
  color: #fe5013;
  font-size: 30px;
}
.adduser {
  background: white;
  padding: 20px 30px;
  margin-top: 10px;
}
.ion-ios-arrowdown {
  padding-left: 8px;
}

// 特惠套餐
.discount-wrap {
  padding: 0 15px;
  box-sizing: border-box;
  margin-top: 15px;
}
.discount-wrap .discount-tips {
  background: #fff;
  border-radius: 6px;
  padding: 15px;
  box-sizing: border-box;
  font-size: 16px;
  color: #333;
  line-height: 1.5;
  font-weight: bold;
}
.discount-content {
  margin-top: 15px;
  background: #fff;
  border-radius: 6px;
  padding: 15px 0 0 15px;
  box-sizing: border-box;
}
.discount-title .limit-num {
  font-size: 18px;
  color: #333;
  font-weight: bold;
  line-height: 2;
}
.discount-title .limit-price {
  font-size: 18px;
  padding-right: 15px;
  color: #e64a3e;
  font-weight: bold;
  line-height: 1.5;
  box-sizing: border-box;
}
.discount-data-wrap .discount-data {
  border-bottom: 1px solid #e4e4e4;
  height: 60px;
  font-size: 16px;
  color: #333;
}
.discount-data-wrap .discount-data:last-child {
  border-bottom: 0;
}
.discount-data-wrap .discount-data .data-time {
  padding-right: 15px;
  box-sizing: border-box;
}
.person{
  position: relative;
}
.ts{
  width: 15px;
  position: absolute;
  top: 2px;
  left:32px;
}
.content-dialog{
  padding: 20px 15px;
  font-size: 16px;
}
</style>